import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, Card, TextField, Grid } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';

export default function AccountChangePassword() {
    const { enqueueSnackbar } = useSnackbar();

    const ChangePassWordSchema = Yup.object().shape({
        oldPassword: Yup.string().required('Old Password is required'),
        newPassword: Yup.string().min(6, 'Password must be at least 6 characters').required('New Password is required'),
        confirmNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    });

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        },
        validationSchema: ChangePassWordSchema,
        onSubmit: async (values, { setSubmitting }) => {
            // await fakeRequest(500);
            setSubmitting(false);
            alert(JSON.stringify(values, null, 2));
            enqueueSnackbar('Save success', { variant: 'success' });
        }
    });

    const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

    return (
        <Grid item xs={12} md={4}>
            <Card sx={{ p: 3 }}>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Stack spacing={3} alignItems="flex-end">
                            <TextField
                                {...getFieldProps('oldPassword')}
                                fullWidth
                                autoComplete="on"
                                type="password"
                                label="Old Password"
                                error={Boolean(touched.oldPassword && errors.oldPassword)}
                                helperText={touched.oldPassword && errors.oldPassword}
                            />

                            <TextField
                                {...getFieldProps('newPassword')}
                                fullWidth
                                autoComplete="on"
                                type="password"
                                label="New Password"
                                error={Boolean(touched.newPassword && errors.newPassword)}
                                helperText={(touched.newPassword && errors.newPassword) || 'Password must be minimum 6+'}
                            />

                            <TextField
                                {...getFieldProps('confirmNewPassword')}
                                fullWidth
                                autoComplete="on"
                                type="password"
                                label="Confirm New Password"
                                error={Boolean(touched.confirmNewPassword && errors.confirmNewPassword)}
                                helperText={touched.confirmNewPassword && errors.confirmNewPassword}
                            />

                            <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                                Save Changes
                            </LoadingButton>
                        </Stack>
                    </Form>
                </FormikProvider>
            </Card>
        </Grid>

    );
}
